/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../app/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], (APIFactory, stringResources, ContentActionsProviderAPI) => {

	class DockAction {

		constructor({ features }) {
			if(features) {
				this._toolbarDock = features.ToolbarDock;
				this._dashboard = features.API;
				this._contentActions = features.ContentActions;
				this._dashboardState = features.DashboardState;
				this._icons = features.Icons;
			}
		}

		initialize() {
			if(this._toolbarDock) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
				this._contentActions.registerProvider('dockToolbarAction', this._api);
			}
		}

		getAPI() {
			return APIFactory.createAPI(this, [ContentActionsProviderAPI]);
		}

		_isAvailable(idList) {
			const isExplore = this._dashboard.getType().toUpperCase()==='EXPLORE';
			return idList.length && !isExplore;
		}

		_isDisabled() {
			return this._dashboardState.getUiState().focus;
		}

		getContentActionList(idList) {
			let contribution;
			if (this._isAvailable(idList)) {
				let icon, tooltip;

				if(this._toolbarDock.isContentToolbarDocked()) {
					icon = this._icons.getIcon('undock-icon').id;
					tooltip = stringResources.get('undockToolbar');
				} else {
					icon = this._icons.getIcon('dock-icon').id;
					tooltip = stringResources.get('dockToolbar');
				}

				contribution = [{
					name: 'dockToolbarAction',
					label: tooltip,
					icon: icon,
					type: 'Button',
					disabled: this._isDisabled.bind(this),
					actions: {
						apply: function() {
							this._toolbarDock.toggle();
						}.bind(this)
					}
				}];
			} else {
				contribution = [];
			}

			return contribution;
		}
	}

	return DockAction;
});
